import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult, NbAuthService, NbRegisterComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { NotifierService } from '../../../_services/notifier.service';
import { UsersService } from '../../../_services/users.service';


/*
La definizione dei valori supportati dal form e della loro validazione è su core.module.ts
source code: https://github.com/akveo/nebular/tree/master/src/framework/auth/components/register
*/
@Component({
    selector: 'ngx-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent extends NbRegisterComponent implements OnInit {

  override user: any;
userFiscalCode: any;


  constructor(
    // Servizi richiesti da NbRegisterComponent
    protected authService: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected override options = {},
    protected override cd: ChangeDetectorRef,
    private alertService: NotifierService,
    private usersService: UsersService,
    protected override router: Router,
  ){
    super(
      authService,
      options,
      cd,
      router,
    );
  }

  ngOnInit(): void {
  }


  override register(): void {
  }
}
